import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './EventMini.css';
import { Link } from 'react-router-dom';
import eventPng1 from '../../../images/webp/event-1.webp';
import eventPng2 from '../../../images/webp/event-2.webp';
import eventPng3 from '../../../images/webp/event-3.webp';
import eventPng4 from '../../../images/webp/event-4.webp';
import boxBlueGif from '../../../images/gif/box-blue.gif';


const EventMini = () => {
    return (
        <div style={{ backgroundImage: `url(${boxBlueGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', borderRadius: 20, padding: '80px 20px' }} >
            <div className="d-flex justify-content-between mt-2">
                <div className="p-2">
                    <h4 data-aos="fade-up" data-aos-duration="2000" className="style-font">Be Event</h4>
                    <h1 data-aos="fade-up" data-aos-duration="3000" className="fw-bolder">Our <span style={{ color: '#ff3465' }}>events</span></h1>
                </div>
                <div data-aos="fade-up" data-aos-duration="3000">
                    <Link to="/events" className="btn rounded-pill me-2 btn-global-style-solid">
                        Book event <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                </div>
            </div>
            <div className="text-center row">
                <div data-aos="fade-up" data-aos-duration="1500" className="col-lg-3 col-6">
                    <div className="img-wrapper m-2">
                        <img className="inner-img w-100" src={eventPng1} alt="" />
                    </div>
                </div>

                <div data-aos="fade-up" data-aos-duration="2000" className=" col-lg-3 col-6">
                    <div className="img-wrapper m-2">
                        <img className="inner-img w-100" src={eventPng2} alt="" />
                    </div>
                </div>

                <div data-aos="fade-up" data-aos-duration="2500" className="col-lg-3 col-6">
                    <div className="img-wrapper m-2">
                        <img className="inner-img w-100" src={eventPng3} alt="" />
                    </div>
                </div>

                <div data-aos="fade-up" data-aos-duration="3000" className=" col-lg-3 col-6">
                    <div className="img-wrapper m-2">
                        <img className="inner-img w-100" src={eventPng4} alt="" />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default EventMini;